import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { get, isEqual, keys, last } from 'lodash';
import CellDisplay from './CellDisplay';
import CellEditable from './CellEditable';

const prepareValue = (val) => {
  if (!val || val === '0') return undefined;
  return val;
};

class Cell extends React.PureComponent {
  isEditing = recordKey => {
    const { cellProps } = this.props;
    const { editable, editingKey } = cellProps;
    return editable && (recordKey === editingKey || recordKey.toString().startsWith('new-row'));
  };

  handleCellClick = () => {
    const { recordKey, onCellClick } = this.props.cellProps;
    return onCellClick(recordKey);
  };

  render() {
    const { cellProps, children, ...props } = this.props;
    const {
      columnKey,
      recordKey,
      value,
      displayPrice,
      expandable,
      hasRenderColumn,
      hasRenderRecord,
      renderRecord,
      validator,
      className,
      editable,
    } = cellProps;
    const tdProps = { ...props };

    let cell = [...children];
    const renderDefault = last(cell) === 'default';
    if (renderDefault) cell.pop();

    if ((!hasRenderColumn || renderDefault)) {
      if (this.isEditing(recordKey)) {
        cell = (
          <CellEditable
            columnKey={columnKey}
            recordKey={recordKey}
            validator={validator}
            options={cellProps.input}
          >
            {prepareValue(value)}
          </CellEditable>
        );
      } else if (!expandable && displayPrice && value) {
        cell = <CellDisplay price={displayPrice}>{value}</CellDisplay>;
      }
    }

    if (hasRenderRecord) {
      cell = renderRecord({ columnKey, recordKey, value, defaultRender: cell });
      // support for format { children, props }
      const cellKeys = keys(cell);
      if (isEqual(cellKeys, ['children', 'props']) || isEqual(cellKeys, ['props'])) {
        Object.assign(tdProps, get(cell, 'props'));
        cell = get(cell, 'children');
      }
    }

    const renderTd = get(tdProps, 'colSpan') !== 0;
    // if renderDefault || hasRenderColumn
    return (
      renderTd && (
        <td
          {...tdProps}
          className={classNames(
            this.isEditing(recordKey) ? `cell-${columnKey} cell-editing-mode` : `cell-${columnKey}`,
            className,
            editable ? 'editable' : '',
          )}
          onClick={this.handleCellClick}
          onKeyDown={this.handleCellClick}
          role="presentation"
        >
          {cell}
        </td>
      )
    );
  }
}

Cell.propTypes = {
  cellProps: PropTypes.object,
  children: PropTypes.any,
};

Cell.defaultProps = {
  cellProps: {},
  children: null,
};

export default Cell;
